import { render } from "./rawmaterial-popup.vue?vue&type=template&id=5e632b09"
import script from "./rawmaterial-popup.vue?vue&type=script&lang=js"
export * from "./rawmaterial-popup.vue?vue&type=script&lang=js"

import exportComponent from "D:\\Cater-Frontend\\cater\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__